<template>
<div class="row col field-list-item2">
  <div v-for="(text, index) in texts" :key="`${index}`"
    class="col"
    :title="text"
  >
    {{text}}
  </div>
</div>
</template>
<script>
export default {
  props: ['texts'],
  data: function () {
    return {
      state: {
        unfold: false
      }
    }
  },
  methods: {
    isEllipsisActive(e) {
      return (e.offsetWidth < e.scrollWidth);
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.field-list-item2 {
  padding: 2px 0px;
}

.field-list-item2 > div {
  overflow:hidden;
  text-overflow: ellipsis;
  padding:0px 15px;
}
</style>
